module.exports = "<div class=\"lecture-section-header\" translate=\"TIMELINE.SECTION\"></div>";